import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Usuario} from '../../modelo/usuario/usuario';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  constructor(private http: HttpClient) {
  }

  registrarUsuario(usuario: Usuario): Observable<any> {
    const body = JSON.stringify({usuario});
    const params = new HttpParams().set('funcion', 'registrarse').set('jsonUsuaio', body);
    return this.enviarSolicitud(params);
  }

  reactivarCuenta(correo: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'reactivarCuenta').set('correo', correo);
    return this.enviarSolicitud(params);
  }

  reenviarMail(correo: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'reenviarMail').set('correo', correo);
    return this.enviarSolicitud(params);
  }

  activarCuenta(correo: string, codigo: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'activarCuenta').set('correo', correo).set('codigo', codigo);
    return this.enviarSolicitud(params);
  }

  cambiarContrasenia(correo: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'olvideContrasenia').set('correo', correo);
    return this.enviarSolicitud(params);
  }

  listarUsuarios(): Observable<any> {
    const params = new HttpParams().set('funcion', 'obtenerUsuarios');
    return this.enviarSolicitud(params);
  }

  obtenerUsuario(idUsuario: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'obtenerUsuario').set('id', idUsuario);
    return this.enviarSolicitud(params);
  }

  registrarUsuarioAdminitrador(usuarioN: Usuario): Observable<any> {
    const body = JSON.stringify({usuarioN});
    const params = new HttpParams().set('funcion', 'amUsuario').set('usuario', body);
    return this.enviarSolicitud(params);
  }

  guardarClicodigo(idUsuario: string, clicodigo): Observable<any> {
    const params = new HttpParams().set('funcion', 'guardarCliCodigo').set('id', idUsuario).set('clicodigo', clicodigo);
    return this.enviarSolicitud(params);
  }

  guardarVip(idUsuario: number, vip:boolean): Observable<any> {
    const params = new HttpParams().set('funcion', 'isVip').set('id', ""+idUsuario).set('vip', vip?'1':'0');
    return this.enviarSolicitud(params);
  }

  guardarEstado(idUsuario: string, estado: string): Observable<any> {
    const params = new HttpParams().set('funcion', 'guardarEstadoUsuario').set('id', idUsuario).set('estado', estado);
    return this.enviarSolicitud(params);
  }

  obtenerUsuarioPerfil() : Observable<any> {
    const params = new HttpParams().set('funcion', 'obtenerUsuarioPerfil');
    return this.enviarSolicitud(params);
  }

  registrarUsuarioPerfil(usuarioM: Usuario): Observable<any> {
    const body = JSON.stringify(usuarioM);
    const params = new HttpParams().set('funcion', 'guardarUsaurioPerfil').set('usuario', body);
    return this.enviarSolicitud(params);
  }

  desactivarCuenta(id_usuario: number) {
    const params = new HttpParams().set('funcion', 'desactivarCuenta').set('id', ''+id_usuario);
    return this.enviarSolicitud(params);
  }
  enviarSolicitud(params: HttpParams): Observable<any> {
    return this.http.post(`${environment.url.gestionUsuario}`, {}, {params});
  }


  guardarContrasenia(contraseniaActual: string, contraseniaNueva: string): Observable<any>  {
    const params = new HttpParams()
      .set('funcion', 'guardarContrasenia')
      .set('contraseniaActual',contraseniaActual)
      .set('contraseniaNueva',contraseniaNueva)
    ;
    return this.enviarSolicitud(params);

  }
}
